import { Box } from '@mui/material';
import { useRecordContext } from 'react-admin';
import ReactJson from 'react-json-view';

export const AppTrackerCommandPanel = () => {
  const record = useRecordContext();

  return (
    <Box sx={{ backgroundColor: '#2d2d2d', p: 2, borderRadius: 1 }}>
      <ReactJson
        src={record}
        theme="monokai"
        displayDataTypes={false}
        enableClipboard={true}
        collapsed={2}
        style={{
          backgroundColor: 'transparent',
          fontFamily: 'monospace',
        }}
      />
    </Box>
  );
};
